export const IibbCategories = {
  ContribuyenteLocal: 1,
  ConvenioMultilateral: 2,
  Exento: 3,
  NoInscripto: 4,
  RegimenSimplificado: 5,
};

export const IibbCategoriesList = [
  { label: 'Exento', value: IibbCategories.Exento }
];